export default __webpack_public_path__ + "static/CentraNo2-BoldItalic-0fbfda89604dac36cd356f6ede2c756f.woff";